const samePayload = (left, right) => JSON.stringify(left) === JSON.stringify(right)

const diffById = (current = [], original = []) => {
  const originalById = new Map(
    original
      .filter((row) => row?.id !== undefined && row?.id !== null)
      .map((row) => [String(row.id), row])
  )

  return current.filter((row) => {
    if (row?.id === undefined || row?.id === null) return true

    const before = originalById.get(String(row.id))
    return !before || !samePayload(row, before)
  })
}

export const buildDetailAttributes = (detail = {}) => ({
  id: detail.id,
  label: detail.label,
  primary: !!detail.primary,

  name: detail.name,
  phone_code_id: detail.phone_code_id === '' ? null : detail.phone_code_id,
  phone: detail.phone,

  complete_address: detail.complete_address,
  city_name: detail.city_name,
  instruction: detail.instruction,

  bank_name: detail.bank_name,
  bank_account_number: detail.bank_account_number,
  bank_account_holder_name: detail.bank_account_holder_name,
  bank_branch: detail.bank_branch,

  notes: detail.notes,
  instagram_account: detail.instagram_account,
  lead_source: detail.lead_source,

  id_card: detail.id_card_signed_id,

  _destroy: String(detail._destroy || '0'),
})

export const buildAddressAttributes = (address = {}) => ({
  id: address.id,
  complete_address: address.complete_address,
  instruction: address.instruction,
  recipient_name: address.recipient_name,
  recipient_number: address.recipient_number,

  latitude:
    address.latitude === '' || address.latitude === undefined || address.latitude === null
      ? null
      : Number(address.latitude),
  longitude:
    address.longitude === '' || address.longitude === undefined || address.longitude === null
      ? null
      : Number(address.longitude),

  _destroy: String(address._destroy || '0'),
})

export const buildNestedAttributesForSave = ({
  mode,
  details = [],
  addresses = [],
  originalDetails = [],
  originalAddresses = [],
}) => {
  if (mode === 'create') {
    return {
      details_attributes: details,
      addresses_attributes: addresses,
    }
  }

  const changedAddresses = diffById(addresses, originalAddresses)
  const changedDetails = diffById(details, originalDetails)

  return {
    // Current backend address phone normalization still uses details_attributes
    // as lookup context. Keep the legacy full-detail context only when an
    // address is actually changed.
    details_attributes: changedAddresses.length > 0 ? details : changedDetails,
    addresses_attributes: changedAddresses,
  }
}
